export default __webpack_public_path__ + "static/media/phone.28bd1e4b.svg";